import { MapContainer, TileLayer, Marker, Popup, Polyline } from "react-leaflet";
import L from "leaflet";
import { Link } from "react-router-dom";
import { Navigation } from "lucide-react";
import { gmapsDir} from "@/lib/api";
import { useLang } from "@/context/LangContext";

const pin = (label, accent) => L.divIcon({ className: `ptg-pin ${accent ? "accent" : ""}`, html: `<span><b>${label}</b></span>`, iconSize: [34, 34], iconAnchor: [17, 34], popupAnchor: [0, -30] });

export default function MapView({ points = [], route = false, height = "h-[520px]", center = [-0.6, 100.4], zoom = 8 }) {
  const { t, money, tr } = useLang();
  const valid = points.filter((p) => typeof p.lat === "number" && typeof p.lng === "number");
  const bounds = valid.length > 1 ? L.latLngBounds(valid.map((p) => [p.lat, p.lng])).pad(0.15) : null;
  return (
    <div data-testid="interactive-map-container" className={`${height} w-full overflow-hidden rounded-3xl border border-slate-200 shadow-sm`}>
      <MapContainer key={valid.map((p) => p.lat).join(",")} center={valid[0] ? [valid[0].lat, valid[0].lng] : center} zoom={zoom} bounds={bounds || undefined} scrollWheelZoom={false} className="h-full w-full">
        <TileLayer attribution='&copy; OpenStreetMap contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {route && valid.length > 1 && <Polyline positions={valid.map((p) => [p.lat, p.lng])} pathOptions={{ color: "#E11D48", weight: 3, dashArray: "6 8" }} />}
        {valid.map((p, i) => (
          <Marker key={i} position={[p.lat, p.lng]} icon={pin(route ? i + 1 : "★", route)}>
            <Popup>
              <div data-testid="map-marker-pin">
                {p.image && <img src={p.image} alt={p.name} className="h-28 w-full object-cover" />}
                <div className="space-y-1.5 p-3">
                  <p className="font-bold text-slate-900 text-sm">{p.name}</p>
                  {p.subtitle && <p className="text-xs text-slate-500">{p.subtitle}</p>}
                  {p.rating && <p className="text-xs">★ <b>{p.rating}</b> · {p.price ? money(p.price, p.city_slug) : t("free")}</p>}
                  <div className="flex gap-2 pt-1">
                    {p.slug && <Link to={`/destinations/${p.slug}`} className="rounded-full bg-slate-900 px-3 py-1 text-xs font-semibold !text-white">{t("details")}</Link>}
                    <a href={gmapsDir(p.lat, p.lng)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold !text-[#064E3B]"><Navigation className="h-3 w-3" />Maps</a>
                  </div>
                </div>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
